import React, { useState, useCallback } from 'react';
import styled from 'styled-components';

import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import useIsScrolledY from '@hooks/useIsScrolledY';
import MainLogo from '../MainLogo';
import HamburgerIcon from '@components/dataDisplay/Icons/HamburgerIcon';
import Button from '@components/dataEntry/button/Button';
import {
  menuFixedState,
  menuTextTypeState,
  menuTypeState,
} from '@atom/setting/homepageSet';
import UserSec from '../common/UserSec';
import { MENU_DESIGN_TYPE } from '@typings/menu/menuType';
import MusicButton from '@template/MusicPlayer/MusicBtn';
import NotificationBtn from '@template/Notifications/NotificationBtn';
import { masterSet } from '@masterSetting/masterSet/masterSetting';
import {
  MENU_TEXT_TYPE,
  MENU_TEXT_TYPE_VALUE,
} from '@typings/menu/menuTextType';
import ChatBtn from '@pages/Chat/ChatBtn';
import { registerOpenState } from '@atom/modal/modal';
import useValidLogin from '@hooks/useValidLogin';
import { scrollbarHide } from '@styles/variants/scrollbar';
import SideMenuPanel from '../common/SideMenuPanel';

const Wrapper = styled.nav<{
  fixed?: boolean;
}>`
  position: ${({ fixed }) => (fixed ? 'fixed' : 'absolute')};
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 3;
  padding-top: env(safe-area-inset-top);
`;

const LogoSec = styled.div`
  display: flex;
  align-items: center;
  img {
    max-height: 60px;
  }
  width: 100%;
  height: 100%;
  overflow: hidden;
  isolation: isolate;
`;

const MobileNavWrapper = styled.nav<{
  isScrolled: boolean;
}>`
  width: 100%;
  height: 60px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
  transition: 0.5s ease background-color, border-bottom;
`;

const UserWrap = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 20px;
  margin-bottom: 12px;
  border-bottom: 1px solid var(--lineColor);
`;

const BtnWrap = styled.div`
  display: flex;
  align-items: center;
  padding: 0 12px;
`;


function HamburgerNav() {
  const setOpenModal = useSetRecoilState(registerOpenState);
  const menuType = useRecoilValue(menuTypeState);
  const menuFixed = useRecoilValue(menuFixedState);
  const isValidLogin = useValidLogin();

  const [showMenu, setshowMenu] = useState(false);
  const isScrolled: boolean = useIsScrolledY({ minScrollY: 100 });
  const closeMenu = useCallback(() => setshowMenu(false), []);

  const toggleMenu = useCallback(() => setshowMenu(!showMenu), [showMenu]);

  return (
    <Wrapper fixed={menuFixed}>
      <MobileNavWrapper
        style={{
          backgroundColor:
            menuType === MENU_DESIGN_TYPE.COLOR
              ? 'var(--menuBackgroundColor)'
              : '',
          backdropFilter:
            menuType === MENU_DESIGN_TYPE.NONE ? '' : 'blur(12px)',
        }}
        isScrolled={isScrolled}
      >
        <LogoSec>
          <MainLogo />
        </LogoSec>
        <BtnWrap>
          <MusicButton color="var(--menuTextColor)" />
          <NotificationBtn
            dropdownDir="topRight"
            color="var(--menuTextColor)"
          />
          {masterSet.chat && <ChatBtn color="var(--menuTextColor)" />}
          <HamburgerIcon
            onClick={() => toggleMenu()}
            isActive={showMenu}
            color="var(--menuTextColor)"
          />
        </BtnWrap>

        {/* 모바일 메뉴: 재사용 사이드 메뉴 패널 */}
        <SideMenuPanel
          show={showMenu}
          onClose={closeMenu}
          header={
            <UserWrap onClick={(e) => e.stopPropagation()}>
              {isValidLogin ? (
                <UserSec
                  dropdownDir="topLeft"
                  showDisplayName
                  close={closeMenu}
                  soundEff={{}}
                />
              ) : (
                <Button shape="stroke" onClick={() => setOpenModal(true)}>
                  로그인
                </Button>
              )}
            </UserWrap>
          }
        />
      </MobileNavWrapper>
    </Wrapper>
  );
}

export default HamburgerNav;
